import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-beneficiary-details',
  templateUrl: './beneficiary-details.component.html',
  styleUrls: ['./beneficiary-details.component.scss'],
  providers: [DatePipe]
})
export class BeneficiaryDetailsComponent implements OnInit {
  @ViewChild('targetTable') targetTable: ElementRef;
  
  selectedLang :any;
  images = [
    // {
    //   previewImageSrc: '../../../assets/home/h-img3.png',
    // },
    {
      previewImageSrc: '../../../assets/home/h-img1.png',
    },
    {
      previewImageSrc: '../../../assets/home/h-img2.png',
    },
    {
      previewImageSrc: '../../../assets/home/h-img4.png',
    },
    {
      previewImageSrc: '../../../assets/home/h-img5.png',
    },
  ];

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  // public benTypeList: any = [];
  public benTypeList: any = [
    {
      benName: 'MI Subsidy',
      benCode: 1
    },
    {
      benName: 'Pond/Tank Subsidy',
      benCode: 2
    }
  ]
  public selectedBenType: any;
  public selectedStartDate: any;
  public selectedEndDate: any;
  public showDataTable: boolean = false;
  public loading: boolean = false;
  public benificaryData: any = [];

  constructor(
    private translateService: TranslateService,
    private datePipe: DatePipe,
    private messageService: MessageService,
    private reportService: ReportsService
    ) {}

  ngOnInit() {
    if(localStorage.getItem('lang')) {
      this.selectedLang = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
      this.translateService.use(this.selectedLang .code)
    }
    this.getBenfTypeList();
    
    this.selectedBenType = {
      benName: 'MI Subsidy',
      benCode: 1
    }

    this.onClickGetData();
  }

  getBenfTypeList(){
    setTimeout(val => {
      this.benTypeList = [
        {
          benName: 'MI Subsidy',
          benCode: 1
        },
        {
          benName: 'Pond/Tank Subsidy',
          benCode: 2
        }
      ]
    }, 100)
  }

  languageChange(event) {
   localStorage.setItem('lang', JSON.stringify(event.value))
       this.translateService.use(event.value.code)   
  }

  onSelectBenType(val){
    this.selectedStartDate = null;
    this.selectedEndDate = null;

    this.onClickGetData();
  }

  // clearGetData(){
  // }

  onClickGetData(){
    let beneficiaryType = this.selectedBenType;   
    // let startDate =  this.datePipe.transform(new Date(this.selectedStartDate), 'yyyy-MM-dd');
    // let endDate =  this.datePipe.transform(new Date(this.selectedEndDate), 'yyyy-MM-dd');
    

    // let reqBody = {
    //   benType: beneficiaryType,
    //   startDate: startDate,
    //   endDate: endDate
    // }

    this.showDataTable = true;

    if(beneficiaryType.benCode == 1){
      this.getMIBeneficiaryData();
    }else if(beneficiaryType.benCode == 2){
      this.getPondBeneficiaryData();
    }
  }

  getPondBeneficiaryData(){
    this.loading = true;
    this.reportService 
      .getPondBeneficiaryReport()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loading = false;
          if(res.length > 0){
            this.benificaryData = res;
          }else{
            this.benificaryData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
          
        },
        error: (err) => {
          this.benificaryData = [];
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getMIBeneficiaryData(){
    this.loading = true;
    this.reportService 
      .getMIBeneficiaryReport('')
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loading = false;
          if(res.length > 0){
            this.benificaryData = res;
          }else{
            this.benificaryData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
        },
        error: (err) => {
          this.benificaryData = [];
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
}
